/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * alliance object
 * @export
 * @interface PostUniverseIdsAlliance
 */
export interface PostUniverseIdsAlliance {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsAlliance
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsAlliance
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsAlliance interface.
 */
export function instanceOfPostUniverseIdsAlliance(value: object): value is PostUniverseIdsAlliance {
    return true;
}

export function PostUniverseIdsAllianceFromJSON(json: any): PostUniverseIdsAlliance {
    return PostUniverseIdsAllianceFromJSONTyped(json, false);
}

export function PostUniverseIdsAllianceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsAlliance {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsAllianceToJSON(json: any): PostUniverseIdsAlliance {
    return PostUniverseIdsAllianceToJSONTyped(json, false);
}

export function PostUniverseIdsAllianceToJSONTyped(value?: PostUniverseIdsAlliance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

